module.exports = __webpack_public_path__ + "img/img_security_korean.64a69134.svg";